import { createGlobalStyle } from 'styled-components';

export const colors = {
  primary: '#9c5939',
  secondary: '#eee0d1',
  background: '#f6f3f0',
  white: '#ffffff',
  text: '#333333',
  textLight: '#666666',
  error: '#d32f2f',
  success: '#388e3c',
  warning: '#f57c00',
  border: '#ddd',
  shadow: 'rgba(0, 0, 0, 0.1)'
};

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: ${colors.background};
    color: ${colors.text};
    line-height: 1.6;
    overflow-x: hidden;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
    outline: none;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    display: block;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${colors.primary};
  }

  /* Scrollbar Styles */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${colors.secondary};
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.primary};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #7d4829;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    body {
      font-size: 14px;
    }
    
    h1 {
      font-size: 24px;
    }
    
    h2 {
      font-size: 20px;
    }
    
    h3 {
      font-size: 18px;
    }
  }

  @media (max-width: 480px) {
    body {
      font-size: 13px;
    }
    
    h1 {
      font-size: 22px;
    }
    
    h2 {
      font-size: 18px;
    }
    
    h3 {
      font-size: 16px;
    }
  }
`;

export default GlobalStyles;

